export default {
  login_id: 'メールアドレス',
  password: 'パスワード'
}
